// 파트너입찰(1억이상)
export default [
  {
    url: "/back",
    name: "분야 바로가기",
    icon: "ArrowLeftIcon",
    activeCode: "",
  },
  {
    url: "/home",
    name: "대시보드",
    icon: "",
    activeCode: "",
  },
  {
    url: "/",
    name: "사업장 현황",
    icon: "",
    activeCode: "",
    submenu: [
      {
        url: "/field/workplace",
        name: "직영사업장",
        icon: "w-line",
        activeCode: "field-workplace",
      },
    ],
  },
  {
    url: "/tab/101",
    name: "안전·보건 경영방침",
    icon: "",
    activeCode: "",
  },
  {
    url: "/",
    name: "안전·보건 조직체계",
    icon: "",
    activeCode: "",
    submenu: [
      {
        url: "/tab/126",
        name: "안전·보건조직 체계도",
        icon: "w-line",
        activeCode: "",
        groupName: ["126"],
      },
      {
        url: "/tab/436",
        name: "유관기관 비상연락망",
        icon: "w-line",
        activeCode: "",
        groupName: ["436"],
      },
    ],
  },
  {
    url: "/",
    name: "안전·보건 예산",
    icon: "",
    activeCode: "",
    submenu: [
      {
        url: "/tab/437",
        name: "안전·보건 예산",
        icon: "w-line",
        activeCode: "",
        groupName: ["437"],
      },
    ],
  },
  {
    url: "/",
    name: "안전·보건 교육",
    icon: "",
    activeCode: "",
    submenu: [
      {
        url: "/tab/434",
        name: "안전·보건 교육",
        icon: "w-line",
        activeCode: "",
        groupName: ["434"],
      },
      {
        url: "/tab/132/page",
        name: "교육 모니터링",
        icon: "w-line",
        activeCode: "",
        groupName: ["132"],
      },
    ],
  },
  {
    url: "/",
    name: "근골격계 유해요인조사",
    icon: "",
    activeCode: "",
    submenu: [
      {
        url: "/tab/293",
        name: "근골격계부담작업 체크리스트",
        icon: "w-line",
        activeCode: "",
        groupName: ["293"],
      },
    ],
  },
  {
    url: "/",
    name: "안전·보건 점검",
    icon: "",
    activeCode: "",
    submenu: [
      {
        url: "/tab/160",
        name: "유해·위험요인 점검(개선)사항 요청",
        icon: "w-line",
        activeCode: "",
        groupName: ["160"],
      },
      {
        url: "/tab/137",
        name: "안전·보건 점검 계획",
        icon: "w-line",
        activeCode: "",
        groupName: ["137"],
      },
      {
        url: "/tab/100",
        name: "안전·보건 합동점검표",
        icon: "w-line",
        activeCode: "",
        groupName: ["100"],
      },
      {
        url: "/tab/289",
        name: "안전·보건 순회점검표(사무실)",
        icon: "w-line",
        activeCode: "",
        groupName: ["289"],
      },
      {
        url: "/tab/439",
        name: "안전 순회점검표(현장)",
        icon: "w-line",
        activeCode: "",
        groupName: ["439"],
      },
      {
        url: "/tab/290",
        name: "보건 순회점검표(현장)",
        icon: "w-line",
        activeCode: "",
        groupName: ["290"],
      },
      {
        url: "/tab/438",
        name: "휴게시설 주요 체크리스트",
        icon: "w-line",
        activeCode: "",
        groupName: ["438"],
      },
      {
        url: "/tab/163",
        name: "일일안전보건점검일지",
        icon: "w-line",
        activeCode: "",
        groupName: ["163"],
      },
      {
        url: "/tab/292",
        name: "근골격계 증상조사표(근로자)",
        icon: "w-line",
        activeCode: "",
        groupName: ["292"],
      },
      {
        url: "/tab/168",
        name: "시설물 관리(공통)",
        icon: "w-line",
        activeCode: "",
        groupName: ["168"],
      },
      {
        url: "/tab/198",
        name: "계절성 업무에 따른 관리대책",
        icon: "w-line",
        activeCode: "",
        groupName: ["198"],
      },
      {
        url: "/tab/580",
        name: "신호 및 연락체계",
        icon: "w-line",
        activeCode: "",
        groupName: ["580"],
      },
    ],
  },
  {
    url: "/",
    name: "안전·보건관리 이행",
    icon: "",
    activeCode: "",
    submenu: [
      {
        url: "/tab/446",
        name: "관리감독자 업무수행평가표",
        icon: "w-line",
        activeCode: "",
        groupName: ["446"],
      },
      {
        url: "/tab/578",
        name: "안전보호구 지급대장",
        icon: "w-line",
        activeCode: "",
        groupName: ["578"],
      },
    ],
  },
  {
    url: "/",
    name: "위험성평가",
    icon: "",
    activeCode: "",
    submenu: [
      {
        url: "/tab/450",
        name: "정기 위험성평가",
        icon: "w-line",
        activeCode: "",
        groupName: ["450"],
      },
      {
        url: "/tab/460",
        name: "수시 위험성평가",
        icon: "w-line",
        activeCode: "",
        groupName: ["460"],
      },
    ],
  },
  {
    url: "/",
    name: "작업허가서",
    icon: "",
    activeCode: "",
    submenu: [
      {
        url: "/tab/457",
        name: "고위험작업허가서",
        icon: "w-line",
        activeCode: "",
        groupName: ["457"],
      },
      {
        url: "/tab/458",
        name: "일반작업허가서",
        icon: "w-line",
        activeCode: "",
        groupName: ["458"],
      },
    ],
  },
  {
    url: "/",
    name: "(중대)산업재해 발생 대비 대책",
    icon: "",
    activeCode: "",
    submenu: [
      {
        url: "/tab/451/page",
        name: "(중대)산업재해 발생 시 보고 절차 안내",
        icon: "w-line",
        activeCode: "",
        groupName: ["451"],
      },
      {
        name: "비상조치 처리 절차",
        icon: "w-line",
        submenu: [
          {
            url: "/filelibrary/454",
            name: "상황별 비상 대비 시나리오",
            activeCode: "filelibrary-454",
            icon: "w-line",
            groupName: ["454"],
          },
          {
            url: "/filelibrary/455",
            name: "사고별·시간별 시나리오",
            activeCode: "filelibrary-455",
            icon: "w-line",
            groupName: ["455"],
          },
          {
            url: "/",
            name: "비상사태 시나리오",
            activeCode: "",
            icon: "w-line",
            // groupName: [""],
          },
        ],
      },
      {
        url: "/tab/242",
        name: "비상조치계획 수립",
        icon: "w-line",
        activeCode: "",
        groupName: ["242"],
      },
      {
        url: "/tab/239",
        name: "비상대피 훈련·교육·평가",
        icon: "w-line",
        activeCode: "",
        groupName: ["239", "240", "241"],
      },
    ],
  },
  {
    url: "/",
    name: "(중대)산업재해 발생 보고",
    icon: "",
    activeCode: "",
    submenu: [
      {
        url: "/tab/117",
        name: "산업재해조사표",
        icon: "w-line",
        activeCode: "",
        groupName: ["117"],
      },
      {
        url: "/tab/244",
        name: "중대재해 발생 보고",
        icon: "w-line",
        activeCode: "",
        groupName: ["244"],
      },
    ],
  },
  {
    url: "/",
    name: "보건관리 현황",
    icon: "",
    activeCode: "",
    submenu: [
      {
        url: '/tab/490',
        name: '물질 안전·보건자료 게시',
        icon: 'w-line',
        activeCode: '',
        groupName: ['490'],
      },
      {
        url: "/tab/447",
        name: "MSDS 리스트 관리",
        icon: "w-line",
        activeCode: "",
      },
    ],
  },
  {
    url: "/mypage",
    name: "마이페이지",
    slug: "safety",
    icon: "",
    submenu: [
      {
        url: "/mypage/workstatus",
        name: "업무현황",
        slug: "",
        icon: "w-line",
        groupName: ["90"],
      },
      {
        url: "/mypage/alert",
        name: "알림",
        slug: "",
        icon: "w-line",
        groupName: ["91"],
      },
      {
        url: "/",
        name: "설정",
        slug: "",
        icon: "w-line",
        submenu: [
          {
            url: "/mypage/info-update",
            name: "개인정보변경",
            slug: "",
            icon: "w-line",
            groupName: ["92"],
          },
        ],
      },
    ],
  },
];
